import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const XIcon = () => {
  return (
    <SvgIcon>
      {/* icon pulled from wikipedia. At the time of creating this component, the official X svg renders blank on all browsers. */}
      {/* https://commons.wikimedia.org/wiki/File:X_logo_2023_original.svg */}
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </SvgIcon>
  );
};

export default XIcon;
